import { IResponse, IResponseMeta } from "../models";

/**
 * Generic response formatter
 * Creates a standardized response object
 */
export function formatResponse<T>(params: {
  success: boolean;
  message: string;
  data?: T | null;
  error?: any;
  meta?: IResponseMeta;
}): IResponse<T> {
  const { success, message, data = null, error = null, meta = {} } = params;

  return {
    success,
    message,
    data,
    error,
    meta,
  };
}
